







import Vue from 'vue'
import Component from 'vue-class-component'

@Component({})
export default class Secondary extends Vue {
  doTheThingZhuLi(): void {
    this.$flows.start('red')
  }
}
